module.exports = __webpack_public_path__ + "img/mod-4.e7ec974c.svg";